angular.module('rjmNg.services').factory 'changelog', [
  "$http"
  "$q"
  "$url"
  "app"
  "derivativeTypes"
  ($http, $q, $url, app, derivativeTypes) ->

    save : (itemId, itemType, eventType, meta = null) ->
      changeData =
        item_type: itemType
        item_id: itemId
        event_type: eventType
        meta: meta

      deferred = $q.defer()
      promise = $http
        method: "POST"
        url: $url("/client/#{app.getClientId()}/changelog")
        data: changeData
      .then ({data}) ->
        deferred.resolve(data)
      .catch () ->
        deferred.reject()
      return deferred.promise

    getMetaFromColumnResponse : (response) ->
      meta =
        derivative_type: derivativeTypes[response.properties.derivative_type]

    getEventTypeFromJournalAction : (action) ->
      if action is 'create'
        return 'created'
      else if action is 'edit'
        return 'changed'
      else if action is 'delete'
        return 'deleted'
      else
        return 'unknown'
  ]
